import AvatarImg from "../../components/ui/AvatarImg";

// Small presentational helpers shared by the messages list.
export function relTime(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const now = new Date();
  const diffMs = now - d;
  const diffMin = Math.floor(diffMs / 60000);
  if (diffMin < 1) return "الآن";
  if (diffMin < 60) return `${diffMin} د`;
  const diffH = Math.floor(diffMin / 60);
  if (diffH < 24 && now.toDateString() === d.toDateString()) {
    return d.toLocaleTimeString("ar-IQ", { hour: "2-digit", minute: "2-digit" });
  }
  const diffD = Math.floor(diffH / 24);
  if (diffD === 1) return "أمس";
  if (diffD < 7) return d.toLocaleDateString("ar-IQ", { weekday: "long" });
  return d.toLocaleDateString("ar-IQ", { month: "short", day: "numeric" });
}

export function Avatar({ name, size = 50, avatarId = "" }) {
  return <AvatarImg name={name} size={size} avatarId={avatarId} />;
}

export function RoleChip({ role }) {
  if (role === "lawyer") {
    return (
      <span className="text-[10px] text-[#B8860B] bg-[#D4AF37]/15 border border-[#D4AF37]/35 rounded-full px-2 py-[1px] font-bold">
        محامٍ
      </span>
    );
  }
  if (role === "client") {
    return (
      <span className="text-[10px] text-[#1E40AF] bg-[#3B82F6]/15 border border-[#3B82F6]/30 rounded-full px-2 py-[1px] font-bold">
        عميل
      </span>
    );
  }
  return null;
}
